<template>
  <input-text
    :value="displayValue"
    :label="label ?? 'Documento Federal'"
    :maxlength="18"
    allowSpecialChars
    :error-messages="erroDocumento ? ['Documento inválido'] : []"
    @input.native="handleInput"
    :hide-details="hideDetails"
  ></input-text>
</template>

<script>
export default {
  props: {
    value: String,
    hideDetails: Boolean,
    label: String
  },
  data() {
    return {
      erroDocumento: false
    };
  },
  computed: {
    displayValue() {
      return this.format(this.value);
    }
  },
  methods: {
    handleInput(e) {
      const raw = e.target.value || '';
      const cleaned = raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

      this.$emit('input', cleaned);
      this.erroDocumento = !this.validarDocumentoFederal(cleaned);
    },

    format(value) {
      const clean = (value || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      if (!clean) return '';

      if (clean.length <= 11) {
        if (clean.length <= 3) return clean;
        if (clean.length <= 6) return clean.slice(0, 3) + '.' + clean.slice(3);
        if (clean.length <= 9)
          return (
            clean.slice(0, 3) + '.' + clean.slice(3, 6) + '.' + clean.slice(6)
          );
        return (
          clean.slice(0, 3) +
          '.' +
          clean.slice(3, 6) +
          '.' +
          clean.slice(6, 9) +
          '-' +
          clean.slice(9)
        );
      }

      if (clean.length <= 12) {
        return (
          clean.slice(0, 2) +
          '.' +
          clean.slice(2, 5) +
          '.' +
          clean.slice(5, 8) +
          '/' +
          clean.slice(8)
        );
      }

      return (
        clean.slice(0, 2) +
        '.' +
        clean.slice(2, 5) +
        '.' +
        clean.slice(5, 8) +
        '/' +
        clean.slice(8, 12) +
        '-' +
        clean.slice(12, 14)
      );
    },

    validarDocumentoFederal(doc) {
      const clean = (doc || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

      if (!clean) return false;
      if (/^\d{11}$/.test(clean)) return this.validarCPF(clean);
      if (/^\d{14}$/.test(clean)) return this.validarCNPJ(clean);
      if (/^[A-Z0-9]{14}$/.test(clean))
        return this.validarCNPJAlfanumerico(clean); // CNPJ novo

      return false;
    },

    validarCNPJAlfanumerico(cnpj) {
      const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      const converterCaractere = caractere =>
        caractere >= 'A' ? caractere.charCodeAt(0) - 48 : parseInt(caractere);

      const validarDigito = indice => {
        let soma = 0;
        for (let i = 0; i < indice; i++) {
          const valor = converterCaractere(cnpj[i]);
          soma += valor * pesos[i + (indice === 12 ? 1 : 0)];
        }
        const resto = soma % 11;
        const digitoEsperado = resto < 2 ? 0 : 11 - resto;
        return parseInt(cnpj[indice]) === digitoEsperado;
      };

      return validarDigito(12) && validarDigito(13);
    },

    validarCPF(cpf) {
      if (/^(\d)\1+$/.test(cpf)) return false;
      const calc = len => {
        let sum = 0;
        for (let i = 0; i < len; i++) sum += parseInt(cpf[i]) * (len + 1 - i);
        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
      };
      return calc(9) === parseInt(cpf[9]) && calc(10) === parseInt(cpf[10]);
    },

    validarCNPJ(cnpj) {
      if (/^(\d)\1+$/.test(cnpj)) return false;
      const calc = len => {
        const pesos =
          len === 12
            ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < len; i++) sum += parseInt(cnpj[i]) * pesos[i];
        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
      };
      return calc(12) === parseInt(cnpj[12]) && calc(13) === parseInt(cnpj[13]);
    }
  }
};
</script>
